import React  from 'react';
import {Button, Grid, Link, Paper, TextField, Typography} from "@material-ui/core";
import logo from '../../assets/images/logo.png'
import '../login/Login.css'
import {NavLink, useNavigate} from "react-router-dom";
import {RouteInfo} from "../../route/RouteHelper";
import {useAuthState} from "../../context/AuthContext";
import {useEffect, useState} from "react";
import Recaptcha from "react-google-recaptcha";
import {convertToMobileNumber} from "../../utils/numberConvertor";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {LoginService} from "../login/LoginService";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";


const ForgetPassword = () => {

    const snackbarState = useSnackbarDispatcher()
    const token = useAuthState().token
    const loading = useLoadingDispatcher()

    const service = new LoginService()


    const navigate = useNavigate()

    useEffect(() => {
        if (typeof token !== "undefined" && token !== null) {
            navigate(RouteInfo.Root.url)
        }
    }, [token])

    const [phoneNumber, setPhoneNumber] = useState("");
    const [nationalCode, setNationalCode] = useState("");


    function handleSendOtpSms() {
        doSendSms()
    }

    function doSendSms() {
        loading(setLoadingStateDispatch(true))
        service.sendOtpSms(nationalCode, phoneNumber)
            .then(response => {
                loading(setLoadingStateDispatch(false))
                navigate(RouteInfo.ConfirmPhoneNumber.globalUrl, {
                    state: {
                        phoneNumber: phoneNumber,
                        nationalCode: nationalCode
                    }
                })
            }).catch(reason => {
            ServerErrorHandler(reason, "خطا در ارسال کد تایید!",snackbarState,loading)
        })
    }

    return (
        <Grid xs={12} id="login-container">
            <Grid style={{width: "100%"}} xs={11} sm={9} md={6} lg={5} xl={3}>
                <Paper id='login-paper' elevation='2'>
                    <img src={logo} alt=""/>
                    <Typography
                        variant='h6'>
                        سامانه مدیریت صندوق های مردمی
                    </Typography>
                    <Typography
                        variant='subtitle2'
                        style={{marginTop: '8px', marginBottom: '1rem'}}
                    >
                        لطفا برای بازیابی رمز عبور مشخصات زیر را وارد نمایید!
                    </Typography>
                    <TextField
                        variant='outlined'
                        label='کد ملی'
                        value={nationalCode}
                        onChange={e => {
                            if (e.target.value.length <= 10)
                                setNationalCode(e.target.value)
                        }}
                        dir={"ltr"}
                    />
                    <TextField
                        variant='outlined'
                        label='شماره تماس'
                        value={convertToMobileNumber(phoneNumber)}
                        onChange={e => {
                            setPhoneNumber(convertToMobileNumber(e.target.value).replaceAll(" ", ""))
                        }}
                        dir={"ltr"}
                    />
                    <div
                        style={{
                            display: "flex",
                            alignContent: "center",
                            justifyContent: "center",
                            padding: "1rem 0 0 0"
                        }}
                        className="w-100">
                       {/* <Recaptcha
                            className='g-recaptcha'
                            sitekey="6LcfFhsfAAAAAK8t0DGlVbxX8trHyM3tmBnfU-5B"
                            render="explicit"
                            onChange={verifyCallback}
                            hl="fa"
                        />*/}
                    </div>
                    <Button className="btn-confirm"
                            onClick={handleSendOtpSms}
                    >
                        ارسال کد تایید
                    </Button>
                    <NavLink
                        className="fs-0"
                        to={RouteInfo.Login.globalUrl}
                    >
                        بازگشت به صفحه ورود
                    </NavLink>

                    <Typography
                        variant='caption'
                        id='copyrightContainer'
                    >
                        <Link
                            href="https://raiko.app"
                            target='_blank'
                            color='inherit'
                            style={{textDecoration: "none"}}
                        >
                            ساخته شده با ❤️ توسط رایکو
                        </Link>
                    </Typography>
                </Paper>

            </Grid>

        </Grid>
    )
}
export default ForgetPassword;